export default {
  form: {
    agreement: {
      label:
        'Ich bestätige, dass meine elektronische Zustimmung der Unterzeichnung dieses Dokuments gleichkommt, und bin mir bewusst, dass meine elektronische Unterschrift verbindlich ist.',
    },
    signed_by: {
      label: 'Name',
      placeholder: 'Name',
    },
    send_to_email: {
      label: 'Vertrag per E-Mail an den Eigentümer senden ({{email}})',
    },
    signer_first_name: {
      label: 'Vorname',
      placeholder: 'Dein Vorname',
    },
    signer_last_name: {
      label: 'Nachname',
      placeholder: 'Dein Nachname',
    },
    recipient_email: {
      label: 'E-Mail-Adresse des Vertragsempfängers',
      placeholder: 'E-Mail-Adresse eingeben',
    },
    additional_locations: {
      label: 'Sollen weitere Standorte zum Vertrag hinzugefügt werden?',
      placeholder: 'Standort suchen und hinzufügen',
    },
    special_agreements: {
      label: 'Besondere Vereinbarungen',
      placeholder: 'Besondere Vereinbarungen eingeben',
    },
  },
  labels: {
    name: 'Name',
    date: 'Datum',
  },
  buttons: {
    sign_in_person: 'Hier mit dem Inhaber unterschreiben',
    back: 'Zurück',
    edit_contract: 'Vertrag bearbeiten',
    skip: 'Überspringen',
    sign: 'Unterschreiben',
    init_sign: 'Vertrag erstellen und senden',
    redo: 'Wiederholen',
    continue: 'Weiter',
    preview: 'Vorschau',
    submit: 'Bestätigen',
  },
  toasts: {
    failed_to_preview_contract: 'Vorschau des Vertrags fehlgeschlagen',
    contract_signing_pending: 'Einen Moment, wir starten gerade deinen Vertrag...',
    failed_to_sign_contract: 'Der Vertrag konnte nicht gestartet werden ⁉️',
    contract_got_signed: 'Der Vertrag wurde erfolgreich gestartet 👌',
  },
  in_person_signing: {
    description:
      'Der Inhaber hat diesen Link per E-Mail erhalten und kann ihn aus der Ferne unterschreiben. Wenn der Inhaber gerade bei Ihnen ist, öffnen Sie die Unterschriftsseite hier.',
  },
  signature_link: {
    label: 'Signatur-Link (derselbe Link, der dem Empfänger per E-Mail gesendet wird)',
    copy: 'Kopieren',
    copied: 'Signatur-Link in die Zwischenablage kopiert',
  },
  header: 'Vertrag erstellen',
  description:
    'Bitte prüfen Sie die Vertragsdaten und geben Sie die E-Mail-Adresse ein, an die der Vertrag gesendet werden soll.',
};
